import { ReactNode } from "react";
import { cx } from "shared/utils";

type RowProps = {
  title: ReactNode;
  value?: string | ReactNode;
  className?: string;
  valueClassName?: string;
  keyClassName?: string;
  fullWidthRow?: boolean;
  growValueWidth?: boolean;
};

const valueWidthClass = (fullWidthRow?: boolean, growValueWidth?: boolean) => {
  if (fullWidthRow) return "";
  return growValueWidth ? "flex-1" : "w-[180px]";
};

export const Row = ({
  title,
  value,
  className,
  valueClassName,
  keyClassName,
  fullWidthRow,
  growValueWidth
}: RowProps) => {
  return (
    <div
      className={cx(
        "flex gap-2 text-sm font-medium",
        fullWidthRow ? "justify-between" : "",
        className
      )}
    >
      <p
        className={cx(
          " text-content-300 print:text-content-800",
          fullWidthRow ? "" : "w-[200px]",
          keyClassName
        )}
      >
        {title}
      </p>
      <p
        className={cx(
          "break-words text-content-1000",
          valueWidthClass(fullWidthRow, growValueWidth),
          valueClassName
        )}
      >
        {value != null && value !== "" ? value : "-"}
      </p>
    </div>
  );
};
